import { ContactFromData } from "../../Order/OrderFinal/Ordering/OrderingContext";

export const getClientFullName = (data: ContactFromData) => {
    const { firstName, lastName, middleName } = data;

    return `${firstName} ${middleName} ${lastName}`
}